import getTopics from 'services/apiHelpers/getTopics';
import getStore from 'services/getStore';
import { updateInteractionsOpenAction } from 'actions/updateInteractionsOpenAction';
import getCurrentTopic from 'services/apiHelpers/getCurrentTopic';
import setCurrentTopic from 'services/apiHelpers/setCurrentTopic';
import onScrollEnds from 'services/onScrollEnds';
import { Block } from 'factories/block';
import { getTopicsNotHiddenFromNextAndBackNavigation } from 'services/getTopicsNotHiddenFromNextAndBackNavigation';

const store = getStore();

let topics: Block[];
let checkWindowHasScrolled;

const getNextInteraction = id => {
  // being more specific with the selector here since it appears that certain extensions ' you know loom you are. . . '
  // are injecting section elements onto the page

  // we only want sections that are within a chameleon topic container
  const topicContainer =
    document.querySelector('[class*="TopicContainer"]') ||
    document.querySelector('[class*="AssessmentContainer"]');
  //

  if (!topicContainer) {
    return;
  }

  // get the section element for scrollingIntoView
  const interactions = Array.from(topicContainer.querySelectorAll('section'));

  const nextInteraction: HTMLElement =
    interactions[
      interactions.findIndex(i => {
        return i.id === `i${id}`;
      }) + 1
    ];

  return nextInteraction;
};

const navToNextTopic = () => {
  if (!topics) {
    topics = getTopics();
  }

  const currentTopic = getCurrentTopic();

  const topicsNotHiddenFromNextAndBackNavigation = getTopicsNotHiddenFromNextAndBackNavigation(
    topics
  );

  const nextTopic =
    topicsNotHiddenFromNextAndBackNavigation[
      topicsNotHiddenFromNextAndBackNavigation.findIndex(t => {
        return t.id === (currentTopic as Block).id;
      }) + 1
    ];

  if (!nextTopic) {
    return;
  }

  console.log(`NAVIGATING TO NEXT TOPIC : ${nextTopic?.props?.name}`);
  setCurrentTopic(nextTopic.id);

  window.scrollTo(0, 0);

  if (
    window['CHAMELEON_EVENTS_API'] &&
    typeof window['CHAMELEON_EVENTS_API'] === 'function'
  ) {
    window['CHAMELEON_EVENTS_API']('NAVIGATION_TO_NEXT_TOPIC');
  }
};

const next = (
  sId: number,
  id: string,
  isFirstInteractionOfTopic: boolean,
  isLastInteractionOfTopic: boolean
) => l => {
  if (l !== 'next') {
    // console.log('branching');

    window.location.hash = l;
    return;
  }

  (window as any).locationHistory = null;

  store.dispatch(updateInteractionsOpenAction(id));

  if (isLastInteractionOfTopic) {
    navToNextTopic();
    return;
  }

  requestAnimationFrame(() => {
    //

    const nextInteraction = getNextInteraction(id);

    if (!nextInteraction) {
      console.warn(
        `nextInteraction not found in the DOM. it likely has not rendered yet`
      );
      return;
    }

    const windowScrollY = window.scrollY;

    clearTimeout(checkWindowHasScrolled);

    nextInteraction.scrollIntoView({
      behavior: 'smooth',
    });

    checkWindowHasScrolled = setTimeout(() => {
      if (window.scrollY === windowScrollY) {
        nextInteraction.scrollIntoView();
        // console.log(
        //   'smooth scrolling failed so we attempt to snap to the nextInteraction'
        // );
      } else {
        // console.log('we have smooth scrolled to the next interaction');
      }
    }, 300);

    //

    onScrollEnds(() => {
      nextInteraction.focus({
        preventScroll: true,
      });
    });
    //
  });
};

export default next;
